import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

/**
 * Emphasizes portions of an input text which match a string
 *
 * @example `
 *  // (assume test = testabc123)
 *  <span [innerHtml]="'testabc123' | highlightText : 'abc'"> </span>
 *   returns
 *  test<strong>abc</strong>123 * `
 *
 */
@Pipe({
  name: 'highlightText',
  pure: false
})
export class HighlightTextPipe implements PipeTransform {
  constructor(private domSanitizer: DomSanitizer) {}
  transform(text: string, searchText: string) {
    if (!searchText || !text) {
      return text;
    }
    const re = new RegExp(searchText, 'gi');
    return text.replace(re, (substr) => `<strong>${substr}</strong>`);
  }
}
